export enum SortOrder {
    newest = "newest",
    oldest = "oldest",
    mostHits = "mostHits",
    leastHits = "leastHits",
    nameAscending = "nameAscending",
    nameDescending = "nameDescending"
}
